// @ts-ignore
import AppLayout from '@/layout/AppLayout.vue';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            redirect: "/dashboard",
            children: [
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: () => import('@/views/pages/Dashboard.vue')
                },
                {
                    path: '/process-mail',
                    name: 'ProcessMail',
                    component: () => import('@/views/pages/processMail/ProcessMail.vue'),
                    meta: { permission: 'mail.create' }
                },
                {
                    path: '/process-mail-out',
                    name: 'ProcessMailOut',
                    component: () => import('@/views/pages/processMail/ProcessMailOut.vue'),
                    meta: { permission: 'mail.process' }
                },
                {
                    path: '/payment-due',
                    name: 'Payment Due',
                    component: () => import('@/views/pages/mailCenter/MailCenterPaymentDue.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/tasks',
                    name: 'Tasks',
                    component: () => import('@/views/pages/mailCenter/MailCenterTasks.vue')
                },
                {
                    path: '/mailbox-requests',
                    name: 'Mailbox Requests',
                    component: () => import('@/views/pages/mailboxes/MailboxRequestList.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/mailbox-requests/:id',
                    name: 'Mailbox Request',
                    props: true,
                    component: () => import('@/views/pages/mailboxes/MailboxRequestView.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/mailboxes',
                    name: 'Mailboxes',
                    component: () => import('@/views/pages/mailboxes/MailboxList.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/mailboxes/new',
                    name: 'New Mailbox',
                    component: () => import('@/views/pages/mailboxes/NewMailboxView.vue'),
                    meta: { permission: 'mailbox.create' }
                },
                {
                    path: '/mailboxes/:id',
                    name: 'Mailbox View',
                    props: true,
                    component: () => import('@/views/pages/mailboxes/MailboxView.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/mail-centers',
                    name: 'MailCenters',
                    component: () => import('@/views/pages/mailCenter/MailCenterList.vue'),
                    meta: { permission: 'mailcenter.view' }
                },
                {
                    path: '/mail-centers/:id',
                    name: 'MailCenterView',
                    props: true,
                    component: () => import('@/views/pages/mailCenter/MailCenterView.vue'),
                    meta: { permission: 'mailcenter.view' }
                },
                {
                    path: '/mail-centers/:id/stripe/return',
                    name: 'MailCenterStripeReturn',
                    props: true,
                    component: () => import('@/views/pages/mailCenter/StripeConnectReturn.vue'),
                    meta: { permission: 'mailcenter.manage_stripe' }
                },
                {
                    path: '/mail-centers/:id/stripe/refresh',
                    name: 'MailCenterStripeRefresh',
                    props: true,
                    component: () => import('@/views/pages/mailCenter/StripeConnectRefresh.vue'),
                    meta: { permission: 'mailcenter.manage_stripe' }
                },
                {
                    path: '/mailbox-plans',
                    name: 'MailboxPlans',
                    component: () => import('@/views/pages/mailboxPlans/MailboxPlansCrud.vue'),
                    meta: { permission: 'mailbox_plan.view' }
                },
                {
                    path: '/agents',
                    name: 'AgentList',
                    component: () => import('@/views/pages/agents/AgentList.vue'),
                    meta: { permission: 'agent.view' }
                },
                {
                    path: '/agents/:id',
                    name: 'AgentView',
                    props: true,
                    component: () => import('@/views/pages/agents/AgentView.vue'),
                    meta: { permission: 'agent.view' }
                },
                {
                    path: '/coupons',
                    name: 'CouponList',
                    component: () => import('@/views/pages/coupons/CouponList.vue'),
                    meta: { permission: 'coupon.view' }
                },
                {
                    path: '/users',
                    name: 'UserList',
                    component: () => import('@/views/pages/users/UserList.vue'),
                    meta: { permission: 'user.view' }
                },
                {
                    path: '/roles',
                    name: 'RoleList',
                    component: () => import('@/views/pages/roles/RoleList.vue'),
                    meta: { permission: 'role.view' }
                },
                {
                    path: '/roles/:id',
                    name: 'RoleView',
                    props: true,
                    component: () => import('@/views/pages/roles/RoleView.vue'),
                    meta: { permission: 'role.view' }
                },
                {
                    path: '/expiring-ids',
                    name: 'ExpiringIds',
                    component: () => import('@/views/pages/ExpiringIdsList.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/missing-data',
                    name: 'MissingData',
                    component: () => import('@/views/pages/MissingDataList.vue'),
                    meta: { permission: 'mailbox.view' }
                },
                {
                    path: '/impersonate',
                    name: 'ImpersonateList',
                    component: () => import('@/views/pages/ImpersonateList.vue'),
                    meta: { permission: 'customer.impersonate' }
                },
                {
                    path: '/refunds',
                    name: 'RefundList',
                    component: () => import('@/views/pages/refunds/RefundList.vue'),
                    meta: { permission: 'payment.view' }
                },
                {
                    path: '/audit-logs',
                    name: 'AuditLogList',
                    component: () => import('@/views/pages/auditLogs/AuditLogList.vue'),
                    meta: { permission: 'audit.view' }
                },
                {
                    path: '/audit-logs-prototypes',
                    name: 'AuditLogPrototypes',
                    component: () => import('@/views/pages/auditLogs/AuditLogPrototypes.vue'),
                    meta: { permission: 'audit.view' }
                },
                {
                    path: '/audit-logs-correlation',
                    name: 'AuditLogCorrelation',
                    component: () => import('@/views/pages/auditLogs/AuditLogCorrelationPrototype.vue'),
                    meta: { permission: 'audit.view' }
                },
            ]
        },
        {
            path: '/link/:id',
            name: 'LinkView',
            props: true,
            component: () => import('@/views/pages/LinkView.vue')
        },
        {
            path: '/notfound',
            name: 'notfound',
            // @ts-ignore
            component: () => import('@/views/pages/errors/NotFound.vue')
        },
        {
            path: '/auth/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        // {
        //     path: '/auth/access',
        //     name: 'accessDenied',
        //     // @ts-ignore
        //     component: () => import('@/views/pages/auth/Access.vue')
        // },
        // {
        //     path: '/auth/error',
        //     name: 'error',
        //     // @ts-ignore
        //     component: () => import('@/views/pages/auth/Error.vue')
        // },
        { path: "/:pathMatch(.*)*", redirect: "/notfound" },
    ]
});

export default router;